<template>
  <div
    class="flex items-start gap-2 rounded-lg bg-info/10 p-3 text-info outline outline-info"
    role="note"
    data-testid="unpaid-invoices-note"
  >
    <fa-icon
      :icon="faCircleInfo"
      class="mt-0.5 size-4 shrink-0"
      aria-hidden="true"
    />
    <span>
      {{ text }}
      <button
        type="button"
        class="inline-flex items-center gap-1 bg-transparent p-0 font-bold text-info underline disabled:cursor-wait"
        :disabled="opening"
        @click="openPortal()"
      >
        {{ t('payment/unpaid_invoices/view') }}
        <fa-icon :icon="faArrowUpRight" class="size-3.5" aria-hidden="true" />
      </button>
    </span>
  </div>
</template>

<script setup lang="ts">
import {
  faArrowUpRight,
  faCircleInfo,
} from '@fortawesome/pro-regular-svg-icons';

const { t } = useI18n();
const { openPortal, opening } = useChargebeePortal();

defineProps<{ text: string }>();
</script>
